import * as Yup from "yup";
import AppConstants from "../../classes/constants";

export const quoteFormInitialValues = {
  first_name: "",
  surname: "",
  email: "",
  phone: "",
  conveyancing: false,
  type: AppConstants.QUOTE_CONVEYANCING_TYPES.BUYER,
  purchase_price: "",
  sale_price: "",
  first_home_buyer: false,
  property_strata_titled: false,
  property_residential_established: true,
  vacant_land: false,
  contract_signed: false,
  is_property_mortgaged: false,
  is_property_deceased_estate: false,
  structural_inspection: false,
  property_address: "",
  property_suburb: "",
  bedroom_count: "",
  bathroom_count: "",
  structural: true,
  structural_maintenance: false,
  timber_pest: false,
};

export const quoteFormValidationSchema = Yup.object().shape({
  first_name: Yup.string().required("Please provide valid first name."),
  surname: Yup.string().required("Please provide valid last name."),
  email: Yup.string()
    .email("Please provide valid email.")
    .required("Please provide valid email."),
  phone: Yup.string()
    .required("Please provide valid phone number.")
    .test(
      "phone",
      "Please provide valid phone number.",
      (val) => val && val.length === 10
    )
    .matches(/^\d+$/, "Please provide valid phone number."),
  conveyancing: Yup.boolean(),
  type: Yup.string().when("conveyancing", {
    is: true,
    then: Yup.string().required("This field is required."),
  }),
  purchase_price: Yup.string().when(["conveyancing", "type"], {
    is: (conveyancing, type) => conveyancing === true && type !== "seller",
    then: Yup.string()
      .required("Please provide valid price.")
      .matches(/^\d+$/, "Please provide valid price.")
      .test(
        "purchase_price",
        `Call <a href="tel:1300001358">1300 001 358</a> for a custom fee quote`,
        (val) => {
          if (AppConstants.MAX_PURCHASE_PRICE === 0) {
            return true;
          }
          return val <= AppConstants.MAX_PURCHASE_PRICE;
        }
      )
      .test("phone", "Please provide valid price.", (val) =>
        val && parseInt(val) > 0 ? true : false
      ),
  }),
  sale_price: Yup.string().when(["conveyancing", "type"], {
    is: (conveyancing, type) => conveyancing === true && type !== "buyer",
    then: Yup.string()
      .required("Please provide valid price.")
      .matches(/^\d+$/, "Please provide valid price.")
      .test(
        "sale_price",
        `Call <a href="tel:1300001358">1300 001 358</a> for a custom fee quote`,
        (val) => {
          if (AppConstants.MAX_SALE_PRICE === 0) {
            return true;
          }
          return val <= AppConstants.MAX_SALE_PRICE;
        }
      )
      .test("phone", "Please provide valid price.", (val) =>
        val && parseInt(val) > 0 ? true : false
      ),
  }),
  first_home_buyer: Yup.boolean(),
  property_strata_titled: Yup.boolean(),
  property_residential_established: Yup.boolean(),
  vacant_land: Yup.boolean(),
  contract_signed: Yup.boolean(),
  is_property_mortgaged: Yup.boolean(),
  is_property_deceased_estate: Yup.boolean(),
  structural_inspection: Yup.boolean(),
  // property_address: Yup.string().required(),
  property_address: Yup.string().when("structural_inspection", {
    is: true,
    then: Yup.string().required("Please provide valid address."),
  }),
  property_suburb: Yup.string().when("structural_inspection", {
    is: true,
    then: Yup.string().required("This field is required."),
  }),
  bedroom_count: Yup.string().when("structural_inspection", {
    is: true,
    then: Yup.string().required("This field is required."),
  }),
  bathroom_count: Yup.string().when("structural_inspection", {
    is: true,
    then: Yup.string().required("This field is required."),
  }),
  structural: Yup.boolean(),
  structural_maintenance: Yup.boolean(),
  timber_pest: Yup.boolean(),
});

export const quoteBedroomOptions = [
  {
    label: "1",
    value: 1,
  },
  {
    label: "2",
    value: 2,
  },
  {
    label: "3",
    value: 3,
  },
  {
    label: "4",
    value: 4,
  },
  {
    label: "5",
    value: 5,
  },
  {
    label: "6+",
    value: 6,
  },
];

export const quoteBathroomOptions = [
  {
    label: "1",
    value: 1,
  },
  {
    label: "2",
    value: 2,
  },
  {
    label: "3",
    value: 3,
  },
  {
    label: "4+",
    value: 4,
  },
];
